<template>
  <Card>
    <CardHeader>
      <CardTitle>People You've Referred</CardTitle>
    </CardHeader>
    <CardContent>
      <ZeroState v-if="referrals.length === 0" class="!p-6">
        <p class="font-bold text-gray-800">No referrals yet</p>
        <p class="mt-2 text-gray-600">Share your referral link or refer an agent manually to start growing the team.</p>
      </ZeroState>
      <ul v-else role="list" class="divide-y divide-gray-200">
        <li v-for="referral in referrals" :key="referral.id" class="py-3 flex items-center justify-between gap-3">
          <div class="min-w-0">
            <p class="text-sm font-medium text-gray-900 truncate">{{ referral.name }}</p>
            <p class="text-xs text-gray-500">
              {{ formatDate(referral.created_at, 'MMMM dd yyyy, h:mm a') }}
            </p>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <ReferralSourceBadge :source-kind="referral.source_kind" />
            <ContactStageBadge :stage="referral.stage" />
          </div>
        </li>
      </ul>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import ZeroState from '@/components/ZeroState.vue';
import DateUtility from '@/utilities/dates';
import ReferralSourceBadge from '@/components/shared/ReferralSourceBadge.vue';
import ContactStageBadge from '@/components/contact/ContactStageBadge.vue';
import type { AgentReferralEntity } from '@/api/entity_types/AgentReferral';

defineProps<{ referrals: AgentReferralEntity[] }>();

const { formatDate } = DateUtility;
</script>
